import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { NavbarComponent } from '../navbar/navbar.component';
import { SmnWarningByAreaResponse, WeatherService } from '../../services/weather.service';
import { AuthService } from '../../services/auth.service';
import { esAdministrador } from '../../shared/administradores';

interface NavItem {
  label: string;
  path: string;
  exact?: boolean;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, NavbarComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  menuOpen = false;
  alertText: string | null = null;

  private readonly baseItems: NavItem[] = [
    { label: 'Inicio', path: '/', exact: true },
    { label: 'Estado actual', path: '/estado-actual' },
    { label: 'Mapas', path: '/mapas' },
    { label: 'Datos y estadísticas', path: '/datos' },
    { label: 'Estadísticas históricas', path: '/estadisticas-historicas' },
    { label: 'Informes', path: '/informes' },
    { label: 'Red de estaciones', path: '/estaciones' }
  ];
  /** Sólo las cuentas de shared/administradores.ts ven "Administración". */
  navItems: NavItem[] = this.baseItems;

  private readonly destroyRef = inject(DestroyRef);
  private readonly authService = inject(AuthService);

  constructor(private weatherService: WeatherService) { }

  ngOnInit(): void {
    this.authService.getUserObservable()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(usuario => {
        this.navItems = esAdministrador(usuario)
          ? [...this.baseItems, { label: 'Administración', path: '/admin' }]
          : this.baseItems;
      });

    this.weatherService.getSmnWarningByArea().subscribe({
      next: (data: SmnWarningByAreaResponse) => {
        this.alertText = this.composeAlertText(data);
      },
      error: () => {
        // No es crítico para el header: si falla, simplemente no se muestra el badge.
      }
    });
  }

  private composeAlertText(data: SmnWarningByAreaResponse): string | null {
    const heat = data.heat?.['3373'];
    const cold = data.cold?.['3373'];

    if (heat && heat.level >= 2) {
      return 'Alerta por temperaturas extremas de calor en la provincia de Tucumán.';
    }
    if (cold && cold.level >= 2) {
      return 'Alerta por temperaturas extremas de frío en la provincia de Tucumán.';
    }
    return null;
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }
}
